export default __webpack_public_path__ + "img/allergy-lactose.f918f1e588716577d852dc7c0acfc35a.svg";